import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';

import { TranslateService } from '@ngx-translate/core';
import { AuthProvider } from '../providers/auth/auth';

import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { PatientsPage } from '../pages/patients/patients';
import { OrdersPage } from '../pages/orders/orders';
import { GroupsPage } from '../pages/groups/groups';
import { AdminClinicsPage } from '../pages/admin-clinics/admin-clinics';
import { AdminUsersPage } from '../pages/admin-users/admin-users';
import { AdminOrdersPage } from '../pages/admin-orders/admin-orders';
import { AdminPrescriptionsPage } from '../pages/admin-prescriptions/admin-prescriptions';
import { AdminUtilityPage } from '../pages/admin-utility/admin-utility';
import { ClinicDoctorsPage } from '../pages/clinic-doctors/clinic-doctors';
import { AdminSuppliesPage } from '../pages/admin-supplies/admin-supplies';
import { SuppliesPage } from '../pages/supplies/supplies';
import { ENV } from '@app/env'
import {ReportsPage} from "../pages/reports/reports";
import {AdminNursinghomePage} from "../pages/admin-nursinghome/admin-nursinghome";
import { ClinicSuppliesDefaultPage } from '../pages/clinic-supplies-default/clinic-supplies-default';
import { OrderProvider } from '../providers/order/order';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage:any = null;
  user:any;

  clinicpages: Array<any>;
  adminpages: Array<any>;
  reportingpages: Array<any>;
  pharmacistpages: Array<any>;

  versionnumber: any;
  enrolmentCount: any;

  userlanguage: string = 'en';

  environment: string;
  clinic_id: any;
  count: any;

  constructor(
    public platform: Platform, 
    public auth: AuthProvider,
    public translate: TranslateService,
    public order: OrderProvider,
    private cd: ChangeDetectorRef
  ) {

    this.initializeApp();
    this.translate.setDefaultLang(this.userlanguage);

    this.versionnumber = ENV.VERSION;

    this.clinicpages = [
      { title: 'Patients', component: PatientsPage, badgecount: null },
      { title: 'Doctors', component: ClinicDoctorsPage, badgecount: null },
      { title: 'Groups', component: GroupsPage, badgecount: null },
      { title: 'Rx Orders', component: OrdersPage, badgecount: null },
      { title: 'Supply Order', component: SuppliesPage, badgecount: null },
      //{ title: 'Default Supplies', component: ClinicSuppliesDefaultPage, badgecount: null },
      { title: 'Rx Report', component: AdminPrescriptionsPage, params: {clinic_user: true}},
      { title: 'Reports', component: ReportsPage, badgecount: null }
    ];

    this.reportingpages = [
      { title: 'Clinics', component: AdminClinicsPage, badgecount: null },
      { title: 'Clinic Doctors', component: ClinicDoctorsPage, badgecount: null },
      { title: 'Master Supplies List', component: AdminSuppliesPage, badgecount: null },
      { title: 'Orders Report', component: AdminOrdersPage, badgecount: null },
      { title: 'System Users', component: AdminUsersPage, badgecount: null },
    ];

    this.adminpages = [
      { title: 'Patients', component: PatientsPage, badgecount: null },
      { title: 'Doctors', component: ClinicDoctorsPage, badgecount: null },
      { title: 'Groups', component: GroupsPage, badgecount: null },
      { title: 'Rx Orders', component: OrdersPage, badgecount: null },
      { title: 'Supply Order', component: SuppliesPage, badgecount: null },
      //{ title: 'Default Supplies', component: ClinicSuppliesDefaultPage, badgecount: null },
      { title: 'Rx Report', component: AdminPrescriptionsPage, params: {clinic_user: true}},
      { title: 'Reports', component: ReportsPage, badgecount: null },
      { title: 'Clinics', component: AdminClinicsPage, badgecount: null },
      { title: 'Clinic Doctors', component: ClinicDoctorsPage, badgecount: null },
      { title: 'Master Supplies List', component: AdminSuppliesPage, badgecount: null },
      { title: 'Orders Report', component: AdminOrdersPage, badgecount: null },
      { title: 'Clinic Rx Report', component: AdminPrescriptionsPage, params: {clinic_user: true}},
      { title: 'Master Rx Report', component: AdminPrescriptionsPage, badgecount: null},
      { title: 'Nursing Homes', component: AdminNursinghomePage, badgecount: null},
      { title: 'System Users', component: AdminUsersPage, badgecount: null },
      { title: 'Utilities', component: AdminUtilityPage, badgecount: null }
    ];

    this.pharmacistpages = [
      { title: 'Clinics', component: AdminClinicsPage, badgecount: null },
      { title: 'Orders Report', component: AdminOrdersPage, badgecount: null },
      { title: 'Clinic Rx Report', component: AdminPrescriptionsPage, params: {clinic_user: true}},
      { title: 'Master Rx Report', component: AdminPrescriptionsPage, badgecount: null},
      { title: 'Nursing Homes', component: AdminNursinghomePage, badgecount: null},
    ]
  }

  async initializeApp() {
    this.environment = ENV.MODE;
    await this.auth.getCurrentUser()
      .then(user => {
        this.user = user;
        console.log('Checking Rx Count');
        this.order.listSize.subscribe(rxcount => {
          console.log('Rx Count: ', rxcount);
          this.count = rxcount;
          this.cd.detectChanges();
        })
        if (user) {
          if (user.roles.clinic_admin || user.roles.retina_admin) {
            this.rootPage = PatientsPage;
          } else {
            this.rootPage = AdminOrdersPage;
          }
        } else {
          this.rootPage = LoginPage
        }
    })


  }


  openPageDirect(page) {
    let navPage: any;
    if (page === 'SuppliesPage')  {
      navPage = SuppliesPage;
    } else if (page === 'ClinicDoctorsPage') {
      navPage = ClinicDoctorsPage;
    } else if (page === 'OrdersPage') {
      navPage = OrdersPage;
    } else if (page === 'GroupsPage') {
      navPage = GroupsPage;
    } else if(page === 'ReportsPage'){
      navPage = ReportsPage;
    } else {
      navPage = PatientsPage;
    }
    this.nav.setRoot(navPage);
  }

  openPrescriptionsPage(){
    this.nav.setRoot(AdminPrescriptionsPage, {clinic_user: true})
  }

  openPage(page) {
    if (page.params) {
      this.nav.setRoot(page.component, page.params);
    } else {
      this.nav.setRoot(page.component);
    }
  }

  async signOut() {
    await this.auth.logout();
    await this.nav.setRoot(LoginPage)
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts